import { type FC } from 'react';
import * as CheckboxUI from '@radix-ui/react-checkbox';
import styles from './Checkbox.module.scss?module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import clsx from 'clsx';

type CheckboxPropsT = {
  id?: string;
  label?: string;
  checked?: boolean | 'indeterminate';
  className?: string;
  labelClassName?: string;
} & Omit<CheckboxUI.CheckboxProps, 'id' | 'checked'>;

const Checkbox: FC<CheckboxPropsT> = ({ label, id, className ,labelClassName,...props }) => {
  const isIndeterminate = props.checked === 'indeterminate';

  return (
    <>
      <CheckboxUI.Root
        className={clsx(styles.Root, className)}
        {...props}
        checked={isIndeterminate ? true : props.checked}
        id={id}
      >
        <CheckboxUI.Indicator className={styles.Indicator}>
          {isIndeterminate ? (
            <FontAwesomeIcon size="xs" color="white" icon={faMinus} />
          ) : (
            <FontAwesomeIcon size="xs" color="white" icon={faCheck} />
          )}
        </CheckboxUI.Indicator>
      </CheckboxUI.Root>
      {label && (
        <label className={clsx(styles.Label, labelClassName)} htmlFor={id}>
          {label}
        </label>
      )}
    </>
  );
};

export default Checkbox;
